import React, { createContext, useReducer } from "react";

import { ActionDef } from "web_modules/PipelineViewer/shared";

export interface View {
  id: number;
  operator_id: number;
  operator_name: string;
  title: string;
  ordered_columns: string[];
  serialized_actions: ActionDef[];
  created_at: string;
  deleted_at: string | null;
  updated_at: string;
}

export const ViewsContext = createContext<{
  views: View[];
  addView: Function;
  editView: Function;
  deleteView: Function;
}>({
  views: [],
  addView: () => {
    alert("not implemented; connect me to a ViewsProvider");
  },
  editView: () => {
    alert("not implemented; connect me to a ViewsProvider");
  },
  deleteView: () => {
    alert("not implemented; connect me to a ViewsProvider");
  },
});
ViewsContext.displayName = "Pipeline View Context";

enum ActionTypes {
  ADD_VIEW,
  EDIT_VIEW,
  DELETE_VIEW,
}

export const ViewsReducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.ADD_VIEW:
      return [...state, action.payload];

    case ActionTypes.EDIT_VIEW:
      return [...state.filter(v => v.id !== action.payload.id), action.payload];

    case ActionTypes.DELETE_VIEW:
      return [...state].filter(v => v.id !== action.payload.id);

    default:
      return state;
  }
};

type Props = {
  views: View[];
};

export function filterViewFields(view: View, fields: string[]): View {
  const filteredView = view;
  filteredView.ordered_columns = view.ordered_columns.filter(col => fields.includes(col));
  filteredView.serialized_actions = view.serialized_actions.filter(a => fields.includes(a.jsonKey));
  return filteredView;
}

export const ViewsProvider: React.FunctionComponent<Props> = ({ views, children }) => {
  const [state, dispatch] = useReducer(ViewsReducer, views);

  const addView = (view: View) => {
    dispatch({
      type: ActionTypes.ADD_VIEW,
      payload: view,
    });
  };

  const editView = (view: View) => {
    dispatch({
      type: ActionTypes.EDIT_VIEW,
      payload: view,
    });
  };

  const deleteView = (view: View) => {
    dispatch({
      type: ActionTypes.DELETE_VIEW,
      payload: view,
    });
  };

  return (
    <ViewsContext.Provider value={{ views: state, addView, editView, deleteView }}>
      {children}
    </ViewsContext.Provider>
  );
};

export default ViewsContext;
